import { useState } from "react";

function SupplierDateTableRow({ index, handleSubmit, setError, t, setAdd, oddIdx }) {
    const [isSubmit, setIsSubmit] = useState(false);
    const today = new Date().toISOString().split("T")[0];
    let startDate = today;
    let endDate =  "";
    const [dates, setDates] = useState({ startDate: startDate, endDate: endDate });

 	const valueHandler = (e) => {
        const { name, value } = e.target;
        if (typeof value === 'undefined') {
            value = "";
        }
        setDates({ ...dates, [name]: value });
    }

    function submitComplete() {
        setIsSubmit(false);
        /*dates.startDate = today;
        dates.endDate = "";*/
    }
    function submitRow() {
        setError("");
        setIsSubmit(true);
        let initialValues = {
			partnershipDateKey: 0,
           	startDate : dates.startDate,
           	endDate : dates.endDate,
        };

        if (!dates.startDate) {
            errors.push(t("error.startdateReqd"));
            setIsSubmit(false);
        } else {
            handleSubmit(1, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        dates.startDate = today;
        dates.endDate = "";
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input
                    type="date"
                    name="startDate"
                    id="startDate"
                    value={dates.startDate || today}
                    min="2000-01-01"
                    onChange={valueHandler}
                    className="form-control rounded-pill shadow-sm px-4 "
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input
                    type="date"
                    name="endDate"
                    id="endDate"
                    value={dates.endDate}
                    min="2000-01-01"
                    onChange={valueHandler}
                    className="form-control rounded-pill shadow-sm px-4 "
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                    <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
	                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
            </td>
        </tr>
    )

}
export default SupplierDateTableRow;